<template>
  <div style="position:relative;" id="content">
    <div style="position: relative;">
      <table   border-spacing='0' cellpadding='0' cellspacing='0' style="width: 150px; table-layout:fixed;word-break:break-all">
        <tr>
          <!-- 收据号 -->
          <td></td>
          <td style="word-wrap:break-word; line-height: 14px;">{{tableData.setlId || ''}}</td>
        </tr>
        <tr>
          <!-- 患者姓名 -->
          <td></td>
          <td style="height: 22px;">{{tableData.userName || ''}}</td>
        </tr>
        <tr>
          <!-- 就诊日期 -->
          <td></td>
          <td style="height: 22px;">{{tableData.modifiedTime || ''}}</td>
        </tr>
        <tr>
          <!-- 就医类别 -->
          <td></td>
          <td style="height: 20px;"></td>
        </tr>
        <tr>
          <td style="height: 18px;"></td>
          <td></td>
        </tr>
        <tr>
          <!-- 合计 -->
          <td></td>
          <td style="height: 22px;">{{tableData.totalAmount || 0}}</td>
        </tr>
        <tr>
          <!-- 统筹支付 -->
          <td></td>
          <td style="height: 22px;">{{tableData.basicMedicalAccountFee || 0}}</td>
        </tr>
        <tr>
          <!-- 账户支付 -->
          <td></td>
          <td style="height: 22px;">{{tableData.insuranceAmount || 0}}</td>
        </tr>
        <tr>
          <!-- 公务员补助 -->
          <td></td>
          <td style="height: 22px;">{{tableData.civilServiceSubsidyTotalAmout || 0}}</td>
        </tr>
        <tr>
          <!-- 大额支付 -->
          <td></td>
          <td style="height: 22px;">{{tableData.entryIntoSeriousIllnessFee || 0}}</td>
        </tr>
        <tr>
          <!-- 药店垫付 -->
          <td></td>
          <td style="height: 22px;"></td>
        </tr>
        <tr>
          <!-- 现金支付 -->
          <td></td>
          <td style="height: 22px;">{{tableData.cashAmount || 0}}</td>
        </tr>
        <tr>
          <!-- 序号 -->
          <td></td>
          <td style="height: 22px;"></td>
        </tr>
        <tr>
          <!-- 收费员 -->
          <td></td>
          <td style="height: 22px;">收费员</td>
        </tr>
      </table>
    </div>
    <div style="position: relative;top:-316px;left: 200px;">
      <table  border-spacing='0' cellpadding='0' cellspacing='0' style="width: 300px; table-layout:fixed">
        <tr>
            {{tableData.userName || ''}}
        </tr>
        <tr>
          <!-- 日期 -->
          <td></td>
          <td style="height: 22px;">{{tableData.modifiedTime || ''}}</td>
          <!-- 医保号 -->
          <td></td>
          <td style="height: 22px;">{{tableData.psnNo || ''}}</td>
        </tr>
        <tr>
          <!-- 就医类别 -->
          <td></td>
          <td></td>
          <!-- 账户余额 -->
          <td></td>
          <td style="height: 18px;">{{tableData.balance || 0}}</td>
        </tr>
        <tr>
          <!-- 费用名称 -->
          <td style="height: 22px;"></td>
          <!-- 金额 -->
          <td></td>
          <!-- 费用名称 -->
          <td></td>
          <!-- 金额 -->
          <td></td>
        </tr>
        <tr>
          <!-- 西药费 -->
          <td></td>
          <td style="height: 22px;">{{tableData.totalAmount || 0}}</td>
          <!-- 中药费 -->
          <td></td>
          <td></td>
        </tr>
        <tr>
          <!-- 其它 -->
          <td style="height: 22px;">其它</td>
          <td>{{tableData.otherPay || 0}}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td style="height: 22px;"></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <!-- 合计金额 -->
          <td style="height: 22px;"></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <!-- 社会保险结算 -->
          <td style="height: 22px;"></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <!-- 基本医疗 -->
          <td></td>
          <td style="height: 22px;">{{tableData.basicMedicalExpenses || 0}}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <!-- 个人自理 -->
          <td></td>
          <td style="height: 22px;">{{tableData.payAmount || 0}}</td>
          <!-- 个人自费 -->
          <td></td>
          <td >{{tableData.payAmount || 0}}</td>
        </tr>
        <tr>
          <!-- 统筹支付 -->
          <td></td>
          <td style="height: 22px;">{{tableData.basicMedicalAccountFee || 0}}</td>
          <!-- 账户支付 -->
          <td></td>
          <td>{{tableData.insuranceAmount || 0}}</td>
        </tr>
        <tr>
          <!-- 公务员补助 -->
          <td></td>
          <td style="height: 22px;">{{tableData.civilServiceSubsidyTotalAmout || 0}}</td>
          <!-- 大额补助 -->
          <td></td>
          <td>{{tableData.entryIntoSeriousIllnessFee || 0}}</td>
        </tr>
        <tr>
          <!-- 药店支付 -->
          <td></td>
          <td></td>
          <!-- 现金支付 -->
          <td></td>
          <td style="height: 22px;">{{tableData.cashAmount || 0}}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td style="height: 22px;">收费员</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import getLodop from '../../../libs/LodopFuncs';

export default {
  name: 'lanZhouPrintModel',
  data() {
    return {
      tableData: {},
    };
  },
  methods: {
    handlePrint() {
      const printContent = document.getElementById('content').innerHTML;
      const LODOP = getLodop();
      LODOP.PRINT_INIT('');
      LODOP.SET_PRINT_PAGESIZE(3, 1600, 1000);
      LODOP.ADD_PRINT_HTM(40, 10, '100%', '100%', printContent);
      LODOP.PRINT();
    },
  },
};
</script>
<style lang="less" scoped>
  td {
    font-size: 14px;
  }
</style>
